"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Amount_1 = require("./Amount");
exports.default = Amount_1.default;
//# sourceMappingURL=index.js.map